import * as Yup from 'yup'

export const initForceChangePasswordValues = {
  oldPassword: '',
  newPassword: '',
  repeatNewPassword: '',
}

export const MIN_PASSWORD_LENGTH = 8

export const ChangeForcePasswordSchema =
  Yup.object().shape({
    oldPassword: Yup.string().required('required'),
    newPassword: Yup.string()
      .min(MIN_PASSWORD_LENGTH, 'minPassLength')
      .required('required'),
    repeatNewPassword: Yup.string()
      .required('repeatPassword')
      .oneOf([Yup.ref('newPassword'), ''], 'passwordsDoNotMatch'),
  })
